export const mockLoungeResults = [
  {
    "search_product_result_id": "4bdfe9c0-d478-4a35-abc4-eeca6b8da721",
    "product_code": "lounges",
    "inventory_provider": "parkvia",
    "inventory_id": "31159-190955",
    "inventory_item": {
      "features": [
        "Feature1"
      ],
      "images": [
        {
          "src": "https://d1yzlzxxfh5mr5.cloudfront.net/images/1564-31159_5c2cb932-fac3-4c72-998c-20fe92318934.jpg",
          "description": "test"
        }
      ],
      "upgrade": {
        "is_for_upgrade_only": false,
        "product_id": null,
        "is_available": false
      },
      "name": "T1 Parkvia",
      "description": "<p>Test</p>",
      "logo": {
        "src": null,
        "description": null
      },
      "additional_fields": {
        "zipcode": {
          "is_required": false,
          "is_show": false
        },
        "inbound_flight_number": {
          "is_required": false,
          "is_show": false
        },
        "phone_number": {
          "is_required": false,
          "is_show": false
        },
        "plate_number": {
          "is_required": false,
          "is_show": false
        },
        "outbound_flight_number": {
          "is_required": false,
          "is_show": false
        }
      },
      "product_option": {
        "name": "Lounge regular",
        "code": "lounge_regular"
      },
      "is_featured": false,
      "entrance_info": "<p>Test</p>",
      "product_logo": {
        "src": null
      }
    },
    "details": {
      "exit_date": "2025-01-25T15:00:00",
      "entry_date": "2025-01-25T13:00:00"
    },
    "inventory_options": [
      {
        "fees": [],
        "meta": {
          "product_option_code": "lounge_regular",
          "direction": null
        },
        "cancellation_policies": [
          {
            "title": "Cancellation Policy",
            "message": "In the event of a cancellation, no refund will be given."
          }
        ],
        "taxes": [],
        "amendment_policies": [
          {
            "title": "Amendment Policy",
            "message": "This booking cannot be amended."
          }
        ],
        "details": {
          "duration": 120,
          "groups": {
            "senior": {
              "is_selected": false
            },
            "adult": {
              "age": {
                "min": 17
              },
              "is_selected": true,
              "totals": {
                "single_total": 35,
                "subtotal": 70,
                "quantity": 2
              }
            },
            "infant": {
              "age": {
                "max": 3,
                "min": 0
              },
              "is_selected": true
            },
            "child": {
              "age": {
                "max": 17,
                "min": 3
              },
              "is_selected": true
            }
          },
          "cancellation_protection": {
            "is_available": false
          },
          "is_parent": true
        },
        "sub_options": [
          {
            "fees": [],
            "internal": {
              "tax_rules": [],
              "expires_at": "2025-01-06T14:12:36+00:00",
              "booking_request": {
                "channel_commission_override_type": null,
                "quantity": 2,
                "provider_partner_name": "ParkVia Lounges",
                "partner_id": 1564,
                "product_type": "lounges",
                "provider": "parkvia",
                "channel_commission_override_value": null,
                "product_id": 190955,
                "product_commission": null,
                "provider_data": {
                  "operatorIdentifier": "easyjet-test-lounge-listing-man",
                  "available": true,
                  "productCode": "2",
                  "price": 70
                },
                "provider_id": 1564,
                "provider_commission_override_value": null,
                "channel_id": 486
              },
              "fee_rules": []
            },
            "meta": {
              "product_option_code": "lounge_regular",
              "direction": null
            },
            "taxes": [],
            "details": {
              "name": "adult",
              "duration": 120,
              "name_formatted": "Adult"
            },
            "id": 190956,
            "totals": {
              "fees": 0,
              "total": 70,
              "quantity": 2,
              "subtotal": 70,
              "bundle_saving": 0,
              "discount": 0,
              "taxes": 0,
              "currency": "GBP",
              "exchange": null,
              "channel_based": {
                "total": 70,
                "total_discounted": 70
              }
            },
            "is_available": true
          }
        ],
        "id": 190955,
        "totals": {
          "fees": 0,
          "total": 70,
          "quantity": 2,
          "subtotal": 70,
          "bundle_saving": 0,
          "discount": 0,
          "taxes": 0,
          "currency": "GBP",
          "exchange": null,
          "channel_based": {
            "total": 70,
            "total_discounted": 70
          }
        },
        "is_available": true
      }
    ]
  },
  {
    "search_product_result_id": "e1e1a63a-29f3-4bde-8554-e11ae36dc1ab",
    "product_code": "lounges",
    "inventory_provider": "internal",
    "inventory_id": "18587-123431",
    "inventory_item": {
      "images": [
        {
          "src": "https://d1yzlzxxfh5mr5.cloudfront.net/images/1185-18587_ab749cae-b358-42b3-b465-3680443b68b8.png",
          "description": "AB lounge without CP"
        }
      ],
      "visiting_duration": null,
      "upgrade": null,
      "baggage_type": null,
      "description": "<p>AB lounge without CP</p>",
      "additional_fields": {
        "zipcode": {
          "is_required": false,
          "is_show": false
        },
        "inbound_flight_number": {
          "is_required": false,
          "is_show": false
        },
        "phone_number": {
          "is_required": false,
          "is_show": false
        },
        "plate_number": {
          "is_required": false,
          "is_show": false
        },
        "outbound_flight_number": {
          "is_required": false,
          "is_show": false
        }
      },
      "airline_name": null,
      "product_option": {
        "name": "Lounge regular",
        "code": "lounge_regular"
      },
      "entrance_info": "<p>AB lounge without CP</p>",
      "product_logo": {
        "src": null
      },
      "capacity": {
        "left": 100,
        "message_threshold": null
      },
      "entry_date": "2025-01-17T13:00:00",
      "features": [
        "AB lounge without CP"
      ],
      "bundles": null,
      "name": "AB lounge without CP DN",
      "visiting_duration_message": null,
      "logo": {
        "src": "https://d1yzlzxxfh5mr5.cloudfront.net/images/lounge_logo_c4be2863-bd64-425e-a80e-6ca0f7ed2746.svg",
        "description": "cavu"
      },
      "exit_date": "2025-01-17T14:00:00",
      "pii_questions": {
        "order_management": null,
        "payment": null
      },
      "is_featured": false,
      "direction": null
    },
    "details": {
      "visiting_duration": null,
      "baggage_type": null,
      "visiting_duration_message": null,
      "airline_name": null,
      "direction": null
    },
    "inventory_options": [
      {
        "fees": [],
        "meta": {
          "product_option_code": "lounge_regular",
          "direction": null
        },
        "cancellation_policies": [
          {
            "title": "Cancellation Policy",
            "message": "Free cancellation up to 5 days before arrival. Cancellable with a fee of £5 between 5 days and 1 day before arrival. Non refundable between 1 day and 0 day before arrival."
          }
        ],
        "taxes": [],
        "amendment_policies": [
          {
            "title": "Amendment Policy",
            "message": "Free amendment up to 0 day before arrival."
          }
        ],
        "details": {
          "duration": 60,
          "groups": {
            "senior": {
              "is_selected": true
            },
            "adult": {
              "is_selected": true,
              "totals": {
                "single_total": 20,
                "subtotal": 40,
                "quantity": 2
              }
            },
            "infant": {
              "is_selected": true,
              "exclude_from_capacity": false
            },
            "child": {
              "is_selected": true
            }
          },
          "cancellation_protection": {
            "is_available": false
          },
          "is_parent": true
        },
        "sub_options": [
          {
            "fees": [],
            "internal": {
              "tax_rules": [],
              "expires_at": "2025-01-06T14:07:01+00:00",
              "booking_request": {
                "channel_commission_override_type": null,
                "quantity": 2,
                "provider_partner_name": "Gatwick",
                "check_in_type": "outbound",
                "partner_id": 1185,
                "product_type": "lounges",
                "provider": "internal",
                "channel_commission_override_value": null,
                "product_id": 123431,
                "product_commission": null,
                "provider_data": [],
                "provider_id": null,
                "provider_commission_override_value": null,
                "channel_id": 220
              },
              "fee_rules": []
            },
            "meta": {
              "product_option_code": "lounge_regular",
              "direction": null
            },
            "taxes": [],
            "details": {
              "name": "adult",
              "duration": 60,
              "name_formatted": "Adult"
            },
            "id": 123432,
            "totals": {
              "fees": 0,
              "total": 40,
              "quantity": 2,
              "subtotal": 40,
              "bundle_saving": 0,
              "discount": 0,
              "taxes": 0,
              "currency": "GBP",
              "exchange": null,
              "channel_based": {
                "total": 40,
                "total_discounted": 40
              }
            },
            "is_available": true
          }
        ],
        "id": 123431,
        "totals": {
          "fees": 0,
          "total": 40,
          "quantity": 2,
          "subtotal": 40,
          "bundle_saving": 0,
          "discount": 0,
          "taxes": 0,
          "currency": "GBP",
          "exchange": null,
          "channel_based": {
            "total": 40,
            "total_discounted": 40
          }
        },
        "is_available": true
      }
    ]
  }
]
